'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useCommentContext } from '@/contexts/comment.context';
import { useCommentsContext } from '@/contexts/comments.context';
import { useListComments } from '@/hooks/queries/comment.query';
import { useCommentParams } from '@/hooks/use-comment-params';
import { Comment } from './comment';
import { CommentLoader } from './comment-loader';
export function CommentReplies() {
  const $ = _c(30);
  const {
    comment,
    isOpenReplies,
    setIsOpenReplies
  } = useCommentContext();
  const {
    slug
  } = useCommentsContext();
  const [params] = useCommentParams();
  const t = useTranslations();
  let t0;
  if ($[0] !== comment.id || $[1] !== params.reply || $[2] !== slug) {
    t0 = pageParam => ({
      slug,
      sort: "oldest",
      parentId: comment.id,
      type: "replies",
      highlightedCommentId: params.reply ?? undefined,
      cursor: pageParam
    });
    $[0] = comment.id;
    $[1] = params.reply;
    $[2] = slug;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    data,
    isSuccess,
    isLoading,
    isError,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useListComments(t0, isOpenReplies);
  const {
    ref,
    inView
  } = useInView();
  let t1;
  let t2;
  if ($[4] !== fetchNextPage || $[5] !== hasNextPage || $[6] !== inView) {
    t1 = () => {
      if (inView && hasNextPage) {
        fetchNextPage();
      }
    };
    t2 = [fetchNextPage, hasNextPage, inView];
    $[4] = fetchNextPage;
    $[5] = hasNextPage;
    $[6] = inView;
    $[7] = t1;
    $[8] = t2;
  } else {
    t1 = $[7];
    t2 = $[8];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[9] !== comment.id || $[10] !== params.comment || $[11] !== setIsOpenReplies) {
    t3 = () => {
      if (params.comment === comment.id) {
        setIsOpenReplies(true);
      }
    };
    t4 = [comment.id, params.comment, setIsOpenReplies];
    $[9] = comment.id;
    $[10] = params.comment;
    $[11] = setIsOpenReplies;
    $[12] = t3;
    $[13] = t4;
  } else {
    t3 = $[12];
    t4 = $[13];
  }
  useEffect(t3, t4);
  if (isOpenReplies) {
    let t5;
    if ($[14] !== data || $[15] !== isSuccess) {
      t5 = isSuccess && data.pages.map(_temp2);
      $[14] = data;
      $[15] = isSuccess;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    let t6;
    if ($[17] !== isFetchingNextPage || $[18] !== isLoading) {
      t6 = (isLoading || isFetchingNextPage) && <CommentLoader />;
      $[17] = isFetchingNextPage;
      $[18] = isLoading;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    let t7;
    if ($[20] !== isError || $[21] !== t) {
      t7 = isError && <div className="flex min-h-20 items-center justify-center"><p className="text-sm text-muted-foreground">{t("error.failed-to-load-replies")}</p></div>;
      $[20] = isError;
      $[21] = t;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    let t8;
    if ($[23] !== ref) {
      t8 = <span ref={ref} className="invisible" />;
      $[23] = ref;
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    let t9;
    if ($[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
      t9 = <div className="space-y-8 pl-7">{t5}{t6}{t7}{t8}</div>;
      $[25] = t5;
      $[26] = t6;
      $[27] = t7;
      $[28] = t8;
      $[29] = t9;
    } else {
      t9 = $[29];
    }
    return t9;
  }
  return null;
}
function _temp2(page) {
  return page.comments.map(_temp);
}
function _temp(reply) {
  return <Comment key={reply.id} comment={reply} />;
}